VehiculeValidator.$inject = ['validator'];

export default function VehiculeValidator(validator) {
    const instance = new validator();

    return instance;
}
